<template>
  <generic-container
    v-bind:show_plus="true"
    icon="list ol"
    :title="$t('aspects to evaluate')"
    v-on:add="add"
    :wide="true"
  >
    <!-- <h5 class="ui dividing header">{{ $t("question list") }}</h5> -->

    <!-- <div class="ui styled fluid accordion" v-if="items.length > 0">
      <div v-for="(itm, iidx) in items" :key="iidx">
        <div class="title">
          <i class="dropdown icon"></i>
          {{ itm.prompt | truncate(10) }}
        </div>
        <div class="content">
          <p>
            A dog is a type of domesticated animal. Known for its loyalty and
            faithfulness, it can be found as a welcome guest in many households
            across the world.
          </p>
        </div>
      </div>
    </div> -->
    <div class="ui relaxed divided list">
      <div class="item" v-for="(item, qidx) in items" :key="qidx">
        <i class="check icon"></i>
        <div class="content">
          <div class="fields">
            <div class="two wide field">
              <label>{{ $t("order") }}</label>
              <input type="text" v-model="items[qidx].order" />
            </div>
            <div class="six wide field">
              <label>{{ $t("category") }}</label>
              <div
                class="ui category search"
                ref="category_search"
                :data-idx="qidx"
              >
                <input
                  class="prompt"
                  type="text"
                  :value="translate_category(item.category_id)"
                />
                <div class="results"></div>
              </div>
            </div>
            <div class="six wide field">
              <label>{{ $t("aspect") }} {{ qidx + 1 }}</label>
              <input type="text" v-model="items[qidx].prompt" />
            </div>
            <div class="four wide field">
              <label>{{ $t("maximum answers") }}</label>
              <input type="text" v-model="items[qidx].max_answers" />
            </div>
            <div class="three wide field">
              <div class="ui toggle checkbox">
                <input
                  type="checkbox"
                  name="mandatory"
                  v-model="items[qidx].mandatory"
                />
                <label>{{ $t("mandatory") }}</label>
              </div>
            </div>
            <div class="two wide field">
              <label>{{ $t("options") }} </label>
              <div
                class="ui mini red icon button"
                :data-tooltip="$t('remove')"
                @click="remove(qidx)"
              >
                <i class="trash icon"></i>
              </div>
              <div
                class="ui mini green icon button"
                :data-tooltip="$t('add answer')"
                @click="add_answer(qidx)"
              >
                <i class="plus icon"></i>
              </div>
            </div>
          </div>
          <!-- <div class="ui center aligned message" v-if="qstn.answers.length == 0">
          <div class="content">
            <div class="header">
              {{ $t("no answers added yet!") }}
            </div>
            <p>
              {{
                $t(
                  "you can add answer just by clicking in the green button with plus icon up here",
                )
              }}
            </p>
          </div>
        </div> -->
          <div class="ui basic blue segment">
            <h5 class="ui header">{{ $t("answers") }}</h5>
            <div class="ui list">
              <div
                class="item"
                v-for="(answer, aidx) in item.answers"
                :key="aidx"
              >
                <div class="fields" style="margin-bottom: 0">
                  <div class="two wide field">
                    <label v-if="aidx == 0">{{ $t("order") }}</label>
                    <input
                      type="text"
                      v-model="items[qidx].answers[aidx].order"
                    />
                  </div>
                  <div class="two wide field">
                    <label v-if="aidx == 0">{{ $t("weight") }}</label>
                    <input
                      type="text"
                      v-model="items[qidx].answers[aidx].weight"
                    />
                  </div>
                  <div class="two wide field">
                    <label v-if="aidx == 0">{{ $t("icon") }}</label>
                    <input
                      type="text"
                      v-model="items[qidx].answers[aidx].icon"
                    />
                  </div>
                  <div class="two wide field">
                    <label v-if="aidx == 0">{{ $t("color") }}</label>
                    <input
                      type="text"
                      v-model="items[qidx].answers[aidx].color"
                    />
                  </div>
                  <div class="six wide field">
                    <label v-if="aidx == 0">{{ $t("prompt") }}</label>
                    <input
                      type="text"
                      v-model="items[qidx].answers[aidx].prompt"
                    />
                  </div>
                  <div class="two wide field">
                    <label v-if="aidx == 0">'</label>
                    <div
                      class="ui mini red icon button"
                      :data-tooltip="$t('remove')"
                      @click="remove_answer(qidx, aidx)"
                    >
                      <i class="trash icon"></i>
                    </div>
                  </div>
                  <!-- <div class="three wide field">
                  <label v-if="aidx == 0">{{ $t("preview") }} </label>
                  <div
                    class="ui basic icon labeled button"
                    :style="'background-color: ' + answer.color"
                  >
                    <i :class="answer.icon + ' icon'"></i> {{ answer.prompt }}
                  </div>
                </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui center aligned message" v-if="items.length == 0">
      <div class="content">
        <div class="header">
          {{ $t("no aspects defined yet!") }}
        </div>
        <p>
          {{
            $t(
              "you can add items just by clicking in the green plus button up here",
            )
          }}
        </p>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { init_search } from "@/utils";
// import { FormWizard, TabContent } from "vue-form-wizard";
import { v4 } from "uuid";

export default {
  components: { GenericContainer /* FormWizard, TabContent */ },
  props: { items: Array, categories: Array },
  computed: {},
  data() {
    return {};
  },
  methods: {
    add() {
      let vm = this;
      let suggestedOrder = vm.items.length + 1;
      vm.items.push({
        uuid: v4(),
        order: suggestedOrder,
        prompt: "",
        category_id: "",
        max_answers: 1,
        mandatory: false,
        answers: [
          {
            uuid: v4(),
            prompt: "4",
            icon: "laugh beam outline",
            color: "#40af53 ",
            order: 1,
            weight: "4",
          },
          {
            uuid: v4(),
            prompt: "3",
            icon: "smile outline",
            color: "#3b73bf",
            order: 2,
            weight: "3",
          },
          {
            uuid: v4(),
            prompt: "2",
            icon: "meh outline",
            color: "#e9da45",
            order: 3,
            weight: "2",
          },
          {
            uuid: v4(),
            prompt: "1",
            icon: "frown outline",
            color: "#e94545",
            order: 4,
            weight: "1",
          },
        ],
      });
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    add_answer(index) {
      let vm = this;
      let suggestedOrder = vm.items[index].answers.length + 1;
      vm.items[index].answers.push({
        uuid: v4(),
        prompt: `${vm.$t("option")} ${suggestedOrder}`,
        icon: "check",
        color: "",
        order: suggestedOrder,
        weight: "",
      });
    },
    onComplete() {
      console.log("completed");
    },
    remove_answer(qidx, aidx) {
      this.items[qidx].answers.splice(aidx, 1);
    },
    translate_category(category_id) {
      let vm = this;
      let targetCategory = vm.categories.find(
        (c) => String(c.category_id) == String(category_id),
      );
      if (targetCategory) return targetCategory.name;
      else return category_id;
    },
  },
  watch: {
    items() {
      let vm = this;
      if (vm.items && vm.items.length) {
        setTimeout(() => {
          // console.log("items changed", vm.$refs.category_search);
          let onSearchResponse = (data) => {
            // console.log(data);
            let rslt = [];
            data.map((r) => {
              rslt.push({
                title: r.name,
                // description: r.number,
                category: r,
              });
            });
            return { results: rslt };
          };
          let onSearchSelect = function (data) {
            let itemIdx = window.jQuery(this).data("idx");
            vm.items[itemIdx].category_id = data.category.category_id;
            console.log(data, itemIdx);
            // vm.account = data.account;
          };

          init_search(
            vm,
            this.$refs.category_search,
            "search staff rating category",
            onSearchResponse,
            onSearchSelect,
          );
        }, 500);
      }
    },
  },
};
</script>
